import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IOption } from './button-radio-group-option.model';

@Component({
  selector: 'kh-button-radio-group',
  templateUrl: './button-radio-group.component.html',
  styleUrls: ['./button-radio-group.component.less'],
  standalone: false
})
export class ButtonRadioGroupComponent {
  @Input()
  public options?: IOption[];

  @Input()
  public value: any = null;

  @Output()
  public valueChange = new EventEmitter<any>();

  public notifyChanged(): void {
    this.valueChange.next(this.value);
  }
}
